import axios from 'axios';

const HOST_ENV = process.env.REACT_APP_ENV;

export let API_HOST;
if (HOST_ENV === 'development') {
  API_HOST = 'https://pay-dev.payverseglobal.com';
}
if (HOST_ENV === 'stage') {
  API_HOST = 'https://pay-stg.payverseglobal.com';
}
if (HOST_ENV === 'sandbox') {
  API_HOST = 'https://pay-snd.payverseglobal.com';
}
if (HOST_ENV === 'production') {
  API_HOST = 'https://pay.payverseglobal.com';
}

const ApiInstance = axios.create({
  baseURL: API_HOST,
  // withCredentials: true,
});

function isPaymentMethodListUrl(url: string): boolean {
  const regex = /^\/patment\/methodList\b/;
  return regex.test(url);
}

ApiInstance.interceptors.request.use(config => {
  // 초기화
  if (config.url) {
    if (isPaymentMethodListUrl(config.url)) {
      window.sessionStorage.removeItem('auth');
      window.sessionStorage.removeItem('mid');
      window.sessionStorage.removeItem('clientKey');
    }
  }
  // 헤더 추가
  let auth = window.sessionStorage.getItem('auth');
  let clientKey = window.sessionStorage.getItem('clientKey');
  let mid = window.sessionStorage.getItem('mid');
  if (auth) {
    const accessToken = `Bearer ${auth}`;
    config.headers['Authorization'] = accessToken;
  }
  config.headers['mid'] = mid;
  config.headers['clientKey'] = clientKey;

  if (
    config.url === '/payment/credit' ||
    config.url === '/auth/PV01' ||
    config.url === '/auth/PV02' ||
    config.url === '/auth/PV03' ||
    config.url === '/auth/PVKR'
  ) {
    config.headers['Content-Type'] = 'application/x-www-form-unlencoded';
  }

  // 모바일 분기
  config.headers['os-type'] = 'WEB';
  if (isMobile()) {
    config.headers['os-type'] = 'MWEB';
  }

  // if (getMerchantId() !== '') {
  //   config.headers['merchant-id'] = getMerchantId();
  // } else if (window.sessionStorage.getItem('mid') != null) {
  //   config.headers['merchant-id'] = window.sessionStorage.getItem('mid');
  // } else {
  //   const searchParams = new URLSearchParams(window.location.search);
  //   config.headers['merchant-id'] = searchParams.get('merchant-id');
  //   config.headers['access-token'] = searchParams.get('access-token');
  // }
  return config;
});

function isMobile() {
  var result = false;

  var UserAgent = navigator.userAgent;
  if (
    UserAgent.match(
      /iPhone|iPad|iPod|Android|Windows CE|BlackBerry|Symbian|Windows Phone|webOS|Opera Mini|Opera Mobi|POLARIS|IEMobile|lgtelecom|nokia|SonyEricsson/i,
    ) != null ||
    UserAgent.match(/LG|SAMSUNG|Samsung/) != null
  ) {
    result = true;
  } else {
    result = false;
  }

  //iPad
  const ua = window.navigator.userAgent.toLowerCase();
  const isiPad =
    ua.indexOf('ipad') > -1 ||
    (ua.indexOf('macintosh') > -1 && 'ontouchend' in document);
  const isiOS =
    ua.indexOf('iphone') > -1 ||
    ua.indexOf('ipad') > -1 ||
    (ua.indexOf('macintosh') > -1 && 'ontouchend' in document);
  const isMac = ua.indexOf('macintosh') > -1 && !('ontouchend' in document);

  if (isiPad || isiOS) {
    result = true;
  }

  if (isMac) {
    result = false;
  }

  return result;
}

export default ApiInstance;
